import { render } from "./ParentInfo.vue?vue&type=template&id=41fdf633&scoped=true&ts=true"
import script from "./ParentInfo.vue?vue&type=script&lang=ts"
export * from "./ParentInfo.vue?vue&type=script&lang=ts"

import "./ParentInfo.vue?vue&type=style&index=0&id=41fdf633&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fdf633"]])

export default __exports__